import { forwardRef } from 'react';
import ReactDatePicker from 'react-datepicker';
import styled from 'styled-components';
import tw from 'twin.macro';

import 'react-datepicker/dist/react-datepicker.css';

const ReactDatePickerHolder = styled.div`
  .react-datepicker-wrapper {
    display: flex;
  }

  .react-datepicker-popper {
    ${tw`z-50`};
  }

  .react-datepicker__triangle {
    ${tw`hidden`};
  }

  .react-datepicker {
    ${tw`bg-page-background border border-solid border-gray-1`}
  }

  .react-datepicker__header {
    ${tw`bg-neutral-background border-b border-solid border-gray-1`}
  }

  .react-datepicker__current-month {
    ${tw`text-text-and-icon`}
  }

  .react-datepicker__day-name {
    ${tw`text-text-and-icon`}
  }

  .react-datepicker__month {
    ${tw`bg-page-background`}
  }

  .react-datepicker__day {
    ${tw`text-text-and-icon`}
  }

  .react-datepicker__day:hover {
    ${tw`text-text-and-icon-invert bg-accent-muted`}
  }

  .react-datepicker__day--keyboard-selected {
    ${tw`text-text-and-icon-invert bg-accent-2`}
  }

  .react-datepicker__day--in-range {
    ${tw`text-text-and-icon-invert bg-accent-2`}
  }

  .react-datepicker__day--in-selecting-range:not(
      .react-datepicker__day--in-range,
      .react-datepicker__month-text--in-range,
      .react-datepicker__quarter-text--in-range,
      .react-datepicker__year-text--in-range
    ) {
    ${tw`text-text-and-icon-invert bg-accent-muted`}
  }

  .react-datepicker__navigation-icon::before {
    ${tw`border-text-and-icon-muted-2`}
  }

  @media (max-width: 370px) {
    .react-datepicker-wrapper {
      ${tw`w-full inline-block`};
    }

    .react-datepicker__month-container {
      ${tw`float-none`};
    }

    .react-datepicker__time-container {
      ${tw`float-none w-full border-l-0`};
    }

    .react-datepicker__navigation--previous,
    .react-datepicker__navigation--next {
      ${tw`outline-none`};
    }
    .react-datepicker__navigation--next {
      right: 10px;
    }

    .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
      ${tw`w-full m-0`};
    }
  }
`;

const StyledReactDatePicker = styled(ReactDatePicker)`
  ${tw`h-10 px-4 w-full relative cursor-pointer text-base leading-4 flex items-center
    bg-neutral-background text-text-and-icon outline-none bg-no-repeat rounded`};
`;

export const DatePicker = forwardRef((props, ref) => {
  return (
    <ReactDatePickerHolder>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <StyledReactDatePicker {...props} ref={ref} />
    </ReactDatePickerHolder>
  );
});

DatePicker.displayName = 'DatePicker';
